import React from "react";
import JsxSyntaxHighlighter from "../../ui/JsxSyntaxHighlighter";
import ApiLink from "../../ui/ApiLink";

export default function ProcessProfileResult() {
  return (
    <>
      <JsxSyntaxHighlighter>
        {`processProFileResult(result: ProFileRawResponse): MinibeakResult`}
      </JsxSyntaxHighlighter>

      <p>
        Processes a <ApiLink name="callProFile" /> result.
      </p>
      <p>
        Returns a <ApiLink name="MinibeakResult" /> with proper resource links,
        easier access to attributes etc.
      </p>

      <p>
        When using React, you will usually not be interested in processing the
        result, because you will be refreshing instances of{" "}
        <ApiLink name="useProFile" /> instead.
      </p>
    </>
  );
}
